import { SHIFT_NAME_COLUMN_WIDTH_PX } from '../../hooks/tableColumns';

/** Placeholder for an empty cell — a dash reads better than a blank cell (shared coordinator/volunteer behaviour). */
const EMPTY_CELL_PLACEHOLDER = '-';

/**
 * Single-line cell text that clips with an ellipsis and exposes the full value via the title tooltip,
 * shared by the volunteer and coordinator shift tables. TruncatedText is a throwing stub in
 * @amzn/awsui-components-react, so truncation is done in CSS. maxWidth bounds the span itself so the
 * ellipsis clips even under table-layout:auto (resizableColumns is off, so the column width is only a
 * hint). An empty/whitespace value renders the dash placeholder rather than a blank cell.
 */
export function TruncatedCellText({ text }: { text?: string }) {
  if (!text?.trim()) return <>{EMPTY_CELL_PLACEHOLDER}</>;
  return (
    <span
      title={text}
      style={{
        display: 'block',
        maxWidth: SHIFT_NAME_COLUMN_WIDTH_PX,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  );
}
